import {configParamsModule} from "../../configParamsModule";
import {IHttpService, IPromise} from "angular";
import userManagementServer from "../../../userManagementServer";

export class PermissionGroupDetailsService {
    constructor(private $http: IHttpService) {
    }

    findPermissionGroupById(permissionGroupId): IPromise<any> {
        return this.$http.get(userManagementServer.getServiceUrl("permission-group.findById") + `/${permissionGroupId}`)
            .then((response: any) => {
                return response.data
            });
    }
}

configParamsModule.service("permissionGroupDetailsService", PermissionGroupDetailsService)